import Vue from "vue";
import Vuex from "vuex";

import GuiCmsStore from "./modules/GuiCmsStore";
import GuiMediaStore from "./modules/GuiMediaStore";
import CwStore from "./modules/CwStore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { guicms: GuiCmsStore, media: GuiMediaStore, cw: CwStore }
});
